(function () {
  var DEBUG = false; // set to true to log actions

  function log() { if (DEBUG) console.log('[a11y-fix]', ...arguments); }

  // Traverse normal DOM and open shadow roots for matches
  function forEachNode(root, selector, fn) {
    root.querySelectorAll(selector).forEach(fn);
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) el.shadowRoot.querySelectorAll(selector).forEach(fn);
    });
  }

  // --- 1) Title link: hidden duplicate -> turn into inert span (keeps aria-hidden)
  function replaceHiddenTitleLink(a) {
    if (!a || a.__pc_processed || a.tagName !== 'A') return;
    if (a.getAttribute('aria-hidden') !== 'true') return; // only process hidden dupes

    var span = document.createElement('span');

    Array.from(a.attributes).forEach(function (attr) {
      var name = attr.name, value = attr.value;
      if (name === 'href' || name === 'tabindex') return;           // drop interactivity
      if (name === 'ref') { span.setAttribute('data-ref', value); return; }
      span.setAttribute(name, value);                                // keep classes, style, etc.
    });

    // Ensure it remains hidden from AT (this is the duplicate title text)
    span.setAttribute('aria-hidden', 'true');

    span.className = a.className;
    span.innerHTML  = a.innerHTML;

    a.replaceWith(span);
    span.__pc_processed = true;
    log('Replaced hidden title link with span', span);
  }

  // --- 2) Gallery link: wrapper link -> turn into non-link span (NO aria-hidden)
  function replaceGalleryWrapperLink(a) {
    if (!a || a.__pc_processed || a.tagName !== 'A') return;
    if (a.getAttribute('ref') !== 'cardGalleryLink') return;

    var span = document.createElement('span');

    Array.from(a.attributes).forEach(function (attr) {
      var name = attr.name, value = attr.value;
      if (name === 'href' || name === 'tabindex' || name === 'aria-label') return; // drop link+label
      if (name === 'ref') { span.setAttribute('data-ref', value); return; }        // preserve reference
      span.setAttribute(name, value);
    });

    // IMPORTANT: do NOT add aria-hidden here—slideshow content must remain accessible
    span.className = a.className;
    span.innerHTML = a.innerHTML;

    a.replaceWith(span);
    span.__pc_processed = true;
    log('Replaced cardGalleryLink anchor with span (kept slideshow accessible)', span);
  }

  // Remove tabindex from anything aria-hidden (scanner complaint)
  function scrubHiddenTabindex(root) {
    forEachNode(root, '[aria-hidden="true"][tabindex]', function (el) {
      el.removeAttribute('tabindex');
      log('Removed tabindex from aria-hidden element', el);
    });
  }

  function process(root) {
    // Title duplicates (hidden)
    forEachNode(root, 'a[ref="productTitleLink"][aria-hidden="true"]', replaceHiddenTitleLink);
    // Gallery wrapper links
    forEachNode(root, 'a[ref="cardGalleryLink"]', replaceGalleryWrapperLink);
    // Clean up tabindex
    scrubHiddenTabindex(root);
  }

  function start() {
    process(document);

    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          process(n);
          if (n.shadowRoot) process(n.shadowRoot);
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Shopify section lifecycle hooks
    ['shopify:section:load','shopify:section:unload','shopify:block:select','shopify:block:deselect']
      .forEach(function (evt) {
        document.addEventListener(evt, function (e) { process(e.target || document); });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
